import React, {Component} from 'react'
import PricingBracketForm from "./bracket.component.jsx"
import {FormattedMessage} from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend';
const uuidv4 = require('uuid/v4')

class PricingBracketsForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            list: this.props.value || [],
            billingMethods: this.props.billingMethods || [],
            unitOfMeasure: this.props.unitOfMeasure || '',
            pricingStrategy: this.props.pricingStrategy || '',
            currency: this.props.currency || AppContext.getAccount().attributes.currency,
        }
        this.deleteItem = this.deleteItem.bind(this)
        this.addItem = this.addItem.bind(this)
        this.changeItem = this.changeItem.bind(this)
    }

    componentDidMount() {
        this.setState({
            list: this.props.value || []
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            list: nextProps.value || [],
            billingMethods: nextProps.billingMethods || [],
            currency: nextProps.currency || AppContext.getAccount().attributes.currency,
            pricingStrategy: nextProps.pricingStrategy || '',
        })
    }

    deleteItem(index) {
        this.setState({
            list: this.state.list.filter((_, i) => i !== index)
        }, () => {
            this.onChange()
        })
    }

    changeItem(index, value) {
        const list = this.state.list
        list[index] = value
        this.setState({
            list: list,
        }, () => {
            this.onChange()
        })
    }

    addItem(e) {
        e.preventDefault()
        const list = this.state.list
        list.push({
            id: uuidv4(),
            fromMeasure: '',
            toMeasure: '',
            cost: '',
            price: '',
            monthlyCost: '',
            monthlyPrice: '',
            yearlyCost: '',
            yearlyPrice: '',
            multiCurrencyPricing: [],
            sequence: '' + list.length,
        })
        this.setState({
            list: list
        }, () => {
            this.onChange()
        })
    }

    onChange() {
        const onChange = this.props.onChange || function () {}
        onChange(this.state.list)
    }

    render() {
        return (
            <div>
                {this.state.list.map((value, index) => {
                    return <PricingBracketForm
                        key={'calculator-term-' + index}
                        value={value}
                        index={index}
                        onDelete={this.deleteItem}
                        onChange={this.changeItem}
                        unitOfMeasure={this.state.unitOfMeasure}
                        billingMethods={this.state.billingMethods}
                        pricingStrategy={this.state.pricingStrategy}
                        currency={this.state.currency}
                    />
                })}
                <div className="row pt-3">
                    <div className="col-12">
                        <button className="btn btn-primary btn-sm" onClick={this.addItem}>
                            <Icon value={"plus-circle"}/>
                            <FormattedMessage
                                id="product.edit.form.custom_bracket.list.add_bracket_btn"
                                defaultMessage="Add a bracket"
                            />
                        </button>
                    </div>
                </div>
            </div>

        );
    }
}

export default PricingBracketsForm


// WEBPACK FOOTER //
// ./src/product/form/custom-bracket/barckets.component.jsx